import { ConfigProvider, message } from "antd";
import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { Root } from "./Root.jsx";
import { ClubProvider } from "./components/club/ClubContext.jsx";

// Localize ant description, and update first day of week for datePicker
import de from "antd/es/locale/de_DE.js";
import en from "antd/es/locale/en_GB.js";
import fr from "antd/es/locale/fr_FR.js";
import nl from "antd/es/locale/nl_NL.js";
import "./components/pwa/register";

const getAntLocal = () => {
  const lng = localStorage.language;

  if (!lng) {
    // check if url is gliding.app, then return en, otherwise nl
    if (window.location.href.indexOf("gliding.app") > -1) {
      return en;
    } else {
      return nl;
    }
  }

  if (lng === "en") return en;
  if (lng === "de") return de;
  if (lng === "fr") return fr;
  // default nl or nl-be
  return nl;
};

// extend Dayjs with relativeTimePlugin
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime.js";
dayjs.extend(relativeTime);

const setDayJSlocale = async () => {
  const lng = localStorage.language;
  if (lng === "en") { await import("dayjs/locale/en"); return dayjs.locale("en"); }
  if (lng === "de") { await import("dayjs/locale/de"); return dayjs.locale("de"); }
  if (lng === "fr") { await import("dayjs/locale/fr"); return dayjs.locale("fr"); }
  await import("dayjs/locale/nl");
  return dayjs.locale("nl");
};

// Empty state props a
export function App({ store }) {
  useEffect(() => {
    
    setDayJSlocale().catch(() => dayjs.locale(window.location.href.indexOf("gliding.app") > -1 ? "en" : "nl"));

    // TODO BADGES: remove test in localStorage
    if (window.location.href.indexOf("no_badges") > -1) {
      console.log(
        "%c✗ Disabling badge display through localStorage test flag",
        "color: red; font-weight: bold;",
      );
      message.info("Badge display disabled through localStorage test flag");
      localStorage.removeItem("badges");
    } else if (window.location.href.indexOf("badges") > -1) {
      console.log(
        "%c✓ Enabling badge display through localStorage test flag (?no_badges to disable)",
        "color: green; font-weight: bold;",
      );
      message.info("Badge display enabled through localStorage test flag");
      localStorage.setItem("badges", "true");
    }
  }, []);

  return (
    <Provider store={store}>
      <ClubProvider>
        <ConfigProvider locale={getAntLocal()}>
          <Root />
        </ConfigProvider>
      </ClubProvider>
    </Provider>
  );
}
